export default "__VITE_ASSET__BrEEMT64__"